<template>
  <div class="container">
    <h1>Salle</h1>
    <h5>{{ room._id }}</h5>

    <div class="form-check mt-4">
      <input
        class="form-check-input"
        type="checkbox"
        :checked="room.authorized"
        v-model="room.authorized"
        id="authorized"
      />
      <label class="form-check-label" for="authorized">Authorized</label>
    </div>

    <router-link
      tag="button"
      class="btn btn-info mt-4"
      :to="{ name: 'Logs', params: { roomId: roomId } }"
      >Voir les logs</router-link
    >

    <div class="container bg-light rounded-lg mt-4 p-4">
      <h2>Versions de la salle:</h2>
      <b-table
        responsive
        small
        borderless
        hover
        :fields="versionFields"
        :items="versionItems"
        class="mt-4"
      >
      </b-table>
    </div>

    <div class="container bg-light rounded-lg mt-4 p-4">
      <h2>Stats</h2>
      <form>
        <div class="form-group">
          <label for="startDate">Min date</label>
          <input
            type="date"
            class="form-control"
            id="startDate"
            v-model="startDate"
          />
        </div>
        <div class="form-group">
          <label for="endDate">Max date</label>
          <input
            type="date"
            class="form-control"
            id="endDate"
            v-model="endDate"
          />
        </div>
      </form>
      <table class="table table-bordered table-striped roomTable">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Nb players</th>
            <th scope="col">Start date</th>
            <th scope="col">End Date</th>
            <th scope="col">Dernier Update</th>
            <th scope="col">Progression</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(stat, index) in room.stats" :key="stat.roomId + index">
            <th>{{ stat.nbPlayer }}</th>
            <td>{{ dateFormat(stat.startDate) }}</td>
            <td>{{ stat.endDate ? dateFormat(stat.endDate) : '' }}</td>
            <td>{{ stat.updatedAt ? dateFormat(stat.updatedAt) : '' }}</td>
            <td>{{ stat.progression }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="container bg-light rounded-lg mt-4 p-4">
      <h2>CID</h2>
      <p class="cid">{{ room.cid || 'Inconnue' }}</p>
      <b-button variant="danger" @click="resetCID">Reset CID</b-button>
    </div>

    <div class="container bg-light rounded-lg mt-4 p-4">
      <h2>Other CIDs</h2>
      <ul class="other-cids-list">
        <li v-for="cid in room.other_cids" :key="cid">{{ cid }}</li>
      </ul>
      <b-button variant="danger" @click="resetOtherCIDs">Reset Other CIDs</b-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { formatDataVersion } from '@/support/metadata.support'

  export default {
    name: 'Room',
    props: ['roomId'],
    data() {
      return {
        room: {},
        startDate: moment().local().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().local().format('YYYY-MM-DD'),
      }
    },
    computed: {
      roomAuth() {
        return this.room.authorized
      },
      versionFields() {
        // return [
        //   { key: 'package', label: 'Application' },
        //   { key: 'game', label: 'Jeux' },
        //   { key: 'question', label: 'Questions' },
        //   { key: 'dmx', label: 'DMX' },
        //   { key: 'media', label: 'Médias' },
        // ]
        return [
          { key: 'type', label: 'Type', thClass: 'd-none' },
          { key: 'version', label: 'Version', thClass: 'd-none' },
        ]
      },
      versionItems() {
        const items = []
        items.push({
          type: 'Application',
          version:
            this.room.metadata && this.room.metadata.version_package
              ? this.room.metadata.version_package
              : this.room.metadata && this.room.metadata.serverVersion
              ? this.room.metadata.serverVersion
              : 'Inconnue',
        })
        items.push({
          type: 'Contenu',
          version: formatDataVersion(this.room.metadata),
        })
        return items
      },
    },
    components: {},
    methods: {
      formatDataVersion,
      dateFormat: function (date) {
        return moment(date).local().format('YYYY-MM-DD HH:mm:ss')
      },
      updateAuthorization() {
        this.authUpdate = true
      },
      getRoom() {
        const token = localStorage.getItem('jwt')
        if (token) {
          axios
            .get('/room/' + this.roomId, {
              params: {
                startDate: this.startDate,
                endDate: this.endDate,
              },
              withCredentials: true,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            })
            .then((response) => {
              this.room = response.data
            })
            .catch(() => {
              this.$router.push('/login')
            })
        } else {
          this.$router.push('/login')
        }
      },
      resetCID() {
        const token = localStorage.getItem('jwt')
        if (token) {
          axios
            .post('/room/' + this.roomId + '/reset-cid', {}, {
              withCredentials: true,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            })
            .then(() => {
              this.room.cid = null
            })
            .catch(() => {
              this.$router.push('/login')
            })
        } else {
          this.$router.push('/login')
        }
      },
      resetOtherCIDs() {
        const token = localStorage.getItem('jwt')
        if (token) {
          axios
            .post('/room/' + this.roomId + '/reset-other-cids', {}, {
              withCredentials: true,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            })
            .then(() => {
              this.room.other_cids = []
            })
            .catch(() => {
              this.$router.push('/login')
            })
        } else {
          this.$router.push('/login')
        }
      },
    },
    mounted() {
      console.log('mounted')
      this.getRoom()
    },
    watch: {
      roomAuth: function () {
        if (!this.room._id) {
          return
        }
        console.log('roomAuth')
        const token = localStorage.getItem('jwt')
        const headers = {
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
        console.log('room', this.room)
        if (token) {
          axios
            .post('/room/' + this.roomId, this.room, headers)
            .then(() => {
              console.log('Room auth updated')
            })
            .catch(() => {
              this.$router.push('/login')
            })
        }
      },
      startDate: function () {
        this.getRoom()
      },
      endDate: function () {
        this.getRoom()
      },
    },
  }
</script>

<style scoped>
  .container {
    margin-top: 2%;
  }

  form {
    width: 40%;
  }

  .roomTable {
    width: 55%;
  }

  .cid {
    color: green;
    font-weight: bold;
  }

  .other-cids-list {
    color: orange;
    font-weight: bold;
  }
</style>
